import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
  AlertColor,
  Alert,
  Snackbar,
} from "@mui/material";
import { DoorData } from "./DoorSettingsPage";
import { getJwtTokenFromIdToken } from "../auth/AuthFanc";

interface ScheduleSettingsProps {
  doorData: DoorData | undefined;
}

const ScheduleSettings: React.FC<ScheduleSettingsProps> = ({ doorData }) => {
  console.log("in door schedule setting");
  console.log(doorData);
  const [scheduleEnabled, setScheduleEnabled] = useState("disabled");
  const [unlockTime, setUnlockTime] = useState<string | undefined>("");
  const [lockTime, setLockTime] = useState<string | undefined>("");

  // アラート
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState<AlertColor>("success");

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
    // window.location.reload();//下部アラートが消えた後に画面リロード
  };

  useEffect(() => {
    console.log("useEffect");
    console.log(doorData);
    setScheduleEnabled(doorData?.isScheduleEnabled ? "enabled" : "disabled");
    setUnlockTime(doorData?.endLock);
    setLockTime(doorData?.startLock);
  }, [doorData]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setScheduleEnabled(event.target.value);
  };

  const handleSave = async () => {
    if (doorData && doorData.sdcUuid) {
      try {
        const isScheduleEnabled = scheduleEnabled === "enabled";
        // call setSchedule API
        const response = await fetch(
          process.env.REACT_APP_API_ENDPOINT +
          `/sdc/${doorData.sdcUuid}/set-schedule`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: await getJwtTokenFromIdToken(),
            },
            body: JSON.stringify({
              isScheduleEnabled: isScheduleEnabled,
              startLock: lockTime,
              endLock: unlockTime,
            }),
          },
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        } else {
          setSnackbarMessage("スケジュールを登録しました。");
          setAlertSeverity("success");
          setSnackbarOpen(true);
        }
      } catch (e) {
        console.error("Error setting schedule:", e);
        setSnackbarMessage("スケジュール登録に失敗しました。");
        setAlertSeverity("error");
        setSnackbarOpen(true);
      }
      // window.location.reload();
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell component="th" scope="row" colSpan={2}>
                  <Typography variant="h6">施錠スケジュール</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>スケジュール:</TableCell>
                <TableCell>
                  <FormControl component="fieldset">
                    <RadioGroup
                      aria-label="schedule"
                      name="schedule"
                      value={scheduleEnabled}
                      onChange={handleChange}
                      row
                    >
                      <FormControlLabel
                        value="enabled"
                        control={<Radio />}
                        label="有効"
                      />
                      <FormControlLabel
                        value="disabled"
                        control={<Radio />}
                        label="無効（常時施錠）"
                      />
                    </RadioGroup>
                  </FormControl>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>解錠時刻:</TableCell>
                <TableCell>
                  <TextField
                    id="unlock-time"
                    label=""
                    type="time"
                    defaultValue={unlockTime}
                    value={unlockTime}
                    onChange={(e) => setUnlockTime(e.target.value)}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>施錠時刻:</TableCell>
                <TableCell>
                  <TextField
                    id="lock-time"
                    label=""
                    type="time"
                    defaultValue={lockTime}
                    value={lockTime}
                    onChange={(e) => setLockTime(e.target.value)}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Box mt={2} display="flex" justifyContent="flex-end">
          <Button variant="outlined" color="primary" onClick={handleSave}>
            スケジュール保存
          </Button>
        </Box>
      </Grid>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={alertSeverity}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default ScheduleSettings;
